import React, { useState } from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import { NODE_NAMES } from '../utils';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import SelectBoxFilter from '../common/select-box-filter';


const useStyles = makeStyles(theme => ({
    btn: {
        fontFamily: 'UniviaPro-Bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#237fc2',
        fontSize: '9px',
        paddingRight: '5px'
    },
    borderBtn: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        marginLeft: 'auto'
    },
    borderCard: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        border: "solid 1px #c1e5fa",
        marginTop: theme.spacing(2),
        padding: theme.spacing(3, 2)
    },
    titleNodeType: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },

}));

export const NODE_TYPES = [
    { id: 1, name: NODE_NAMES.INFO },
    { id: 2, name: NODE_NAMES.APPLICATION },
    { id: 3, name: NODE_NAMES.LINKED_MENU },
    { id: 4, name: NODE_NAMES.CONTACT },
    { id: 5, name: NODE_NAMES.MESSAGE },
    { id: 6, name: NODE_NAMES.SCHEDULE },
    { id: 7, name: NODE_NAMES.AUDIO },
];

function NodeType() {
    const classes = useStyles();
    const translate = useTranslate();
    const dispatch = useDispatch();

    const [openPoper, setOpenPopper] = useState(false);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);

    const onChangeType = (value) => {
        const newData = {
            ...nodeSelected.applicationData,
            nodeType: value
        };
        dispatch(changeNodeGlobalData(newData));
    }

    return (
        <Box className={classes.borderCard} >
            <Typography style={{ marginTop: '10px' }} className={classes.titleNodeType}>{translate(`resources.infoPage.nodeType`)}</Typography>
            <Box display='flex' style={{ marginRight: '47px', position: 'relative' }}>
                <Box width="500px" mt={2} >
                    <SelectBoxFilter
                        disabled={!isEditing}
                        data={NODE_TYPES}
                        label={translate('resources.infoPage.infoPageType')}
                        value={nodeSelected.applicationData.nodeType}
                        onChange={(value) => onChangeType(value.name)}
                        keyName='name'
                        placeholder={translate('resources.infoPage.filter_infoPageType')}
                    />

                </Box>
                <Box style={{ position: 'absolute', right: -25, top: 50 }}>
                    <CustomPoper
                        color={'#c1e5fa'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`pos.common.nodeType`)}
                        content={translate(`pos.common.contentNodeType`)}
                        icon={<b>?</b>}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default NodeType;
